import { getFeaturedPostsWidgetConfig } from '../../UserWidgets.deviation_gruser/FeaturedPosts/widgetConfig';
import { getPostsFeedWidgetConfig } from '../../UserWidgets.deviation_gruser/PostsFeed/widgetConfig';

export const getPostsWidgetConfigs = ({ t, dispatch }) => ({
  postsFeed: getPostsFeedWidgetConfig({ t, dispatch }),
  featuredPosts: getFeaturedPostsWidgetConfig({ t, dispatch }),
});
